import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import List from "./ListComponent";
import withPortalHOC from "./WithPortalHOC";
import { useGetOptionsMutation, useLazyGetOptionsMutation } from "../../utils/customer/customerSelect";
import { Done, Refresh, Token } from "@mui/icons-material";
import useRequireAuth from "../../utils/useRequireAuth";
import { ReactComponent as DownArrow } from "../../assets/images/downArrow.svg";
import { ReactComponent as CrossCircle } from "../../assets/images/icons/cross-circle.svg";
import { ReactComponent as Tick } from "../../assets/images/icons/TickUniversal.svg";
import DoneIcon from "@mui/icons-material/Done";

const PortalList = withPortalHOC(List);

const SelectComponent = ({
  options = [],
  apiMetaData = null,
  // selectedOptions = [],
  onChange,
  name,
  multiSelect = false,
  startAdornment = null,
  endAdornment = null,
  placeholder = "Select...",
  isTagList = false,
  isEditList = false,
  inlineCrud = false,
  editListHandler = () => null,
  value = null,
  // maxVisibleSelections = 5, // Maximum visible selected options
  toggleButtons = false,
  showSearch = false,
  personList = false,
  size = "medium",
  voucher,
  labelKey = "label",
  valueKey = "value",
  colorKey = "color_code",
  sublabelKey = "sublabel",
  addButton = false,
  addButtonLabel = "Add New Option",
  addButtonAction = () => {},
  error = false,
  disabled = false,
  noChildren,
  // listOpen,
  isError,
  clickTrigger,
  boxWidth = false,
  nullSelector = false,
  listOpen = false,
  expendedList = false,
  noFormInput = false, // Receive selected option onchange, direct as default value, without .value or other format(if any question ask abhishek)
  listCloseHandler = () => null,
  displayValue,
  handleSendIconClick = null,
  showCheckBox = false, // For showing checkbox in search box
  isCompareValue = false,
  heightFull = false,
  apiCall = () => {},
  isRounded = true,
  hideBorder = false,
  className,
  showBalance = false,
  minWidth = "",
  setInitiated = () => {},
  onBlur = () => {},
  textPosition = "start",
}) => {
  const [isOpen, setIsOpen] = useState(listOpen);
  const ref = useRef();
  const refSelect = useRef();
  const refChild = useRef();

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [maxVisibleSelections, setMaxVisibleSelections] = useState(5);
  const [refreshCount, setRefreshCount] = useState(0);

  const user = useRequireAuth();
  const token = user?.token;
  const orgId = user?.org_id;
  const storedData = localStorage.getItem("company_data");
  const myUserData = localStorage.getItem("myUserData");

  const usetoken = myUserData ? JSON.parse(myUserData) : null;
  const tokens = token ? token : usetoken.token;
  const companyId = storedData ? JSON.parse(storedData).company_id : null;

  // console.log("sdelecrt ss", selectedOptions);
  // Close dropdown when clicking outside
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (ref.current && !ref.current.contains(event.target)) {
  //       setIsOpen(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  useEffect(() => {
    if (!value) {
      setSelectedOptions([]);
    } else setSelectedOptions(value);
  }, [value]);

  const [triggerGetOptionsQuery, { data: apiOptionsData }] = useGetOptionsMutation();

  useEffect(() => {
    if (options === null && apiMetaData !== null) {
      const payload = {};
      if (apiMetaData?.payload?.company_id) {
        payload.company_id = companyId;
      }
      if (apiMetaData?.payload?.org_id) {
        payload.org_id = orgId;
      }
      if (true) {
        payload.voucher_type_id = voucher?.id;
      }
      triggerGetOptionsQuery({ payload: { lookup_key: apiMetaData.lookup_key, payload }, tokens });
    }
  }, [options, apiMetaData, tokens, refreshCount]);

  const latestSelectedOptionsRef = useRef(selectedOptions);
  useEffect(() => {
    latestSelectedOptionsRef.current = selectedOptions;
  }, [selectedOptions]);

  const toggleDropdown = () => {
    if (clickTrigger && !isOpen) clickTrigger();
    if (isOpen && !multiSelect) listCloseHandler();
    setIsOpen(() => !isOpen);
    apiCall();
  };

  const handleRemoveOption = (optionValue) => {
    const updatedSelection = selectedOptions.filter((item) => item !== optionValue);
    // onChange(updatedSelection);
    handleChangeOptionClick(updatedSelection);
  };

  const visibleSelections =
    selectedOptions?.length === maxVisibleSelections
      ? selectedOptions
      : selectedOptions?.slice(0, maxVisibleSelections);
  const hiddenCount =
    selectedOptions?.length === maxVisibleSelections ? 0 : selectedOptions.length - visibleSelections?.length;

  const handleChangeOptionClick = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
    if (noFormInput) {
      onChange(selectedOptions);
    } else
      onChange({
        target: {
          value: selectedOptions?.map((item) => item?.[valueKey]),
          name: name,
          ...selectedOptions?.[0]?.additionFields,
          valueObj: selectedOptions,
        },
      });
    if (!multiSelect) {
      setIsOpen(false);
      listCloseHandler();
    }
    // onChange( value);
  };

  const handleSelectAllOptionsClick = (filteredOptions = []) => {
    if (!Array.isArray(filteredOptions) || filteredOptions.length === 0) return;

    const selectedValues = new Set(selectedOptions.map((o) => o.value));
    const allVisibleSelected = filteredOptions.every((o) => selectedValues.has(o.value));

    let newSelectedOptions;

    if (allVisibleSelected) {
      // ✅ All visible items already selected → remove them (unselect)
      const toRemove = new Set(filteredOptions.map((o) => o.value));
      newSelectedOptions = selectedOptions.filter((o) => !toRemove.has(o.value));
    } else {
      // ✅ Some or none visible items selected → add only missing ones
      const missing = filteredOptions.filter((o) => !selectedValues.has(o.value));
      newSelectedOptions = [...selectedOptions, ...missing];
    }

    setSelectedOptions(newSelectedOptions);

    // 🔁 Fire onChange based on context
    if (noFormInput) {
      onChange(newSelectedOptions);
    } else {
      onChange({
        target: {
          value: newSelectedOptions.map((item) => item.value),
          name,
          ...(filteredOptions?.[0]?.additionFields || {}),
          valueObj: newSelectedOptions,
        },
      });
    }
  };

  // console.log(selectedOptions, "selected Options aakash");
  const errorStyleClass = "border-b-2 border-b-[#EF4444]";
  const activeStyleClass = "border-[#7A7D84]";
  const disabledStyleClass = "border-DFE2E5 bg-EDEDED text-868686 !cursor-not-allowed";

  const dynamicClassDefinition = () => {
    if (disabled) {
      return disabledStyleClass;
    } else if (isOpen) {
      return activeStyleClass;
    } else if (isError && selectedOptions?.length < 1 && !isOpen) {
      return errorStyleClass;
    }
  };

  const isOpenRef = useRef(isOpen);

  useEffect(() => {
    isOpenRef.current = isOpen;
  }, [isOpen]);

  const handleOutsideClick = (event) => {
    if (refSelect.current && !refSelect.current.contains(event.target) && !isOpen) {
      if (noFormInput) {
        listCloseHandler(selectedOptions);
      } else {
        listCloseHandler({
          target: {
            value: latestSelectedOptionsRef.current?.map((item) => item?.value),
            name: name,
            ...latestSelectedOptionsRef.current?.[0]?.additionFields,
          },
        });
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  });

  useLayoutEffect(() => {
    // function getVisibleChildren(ulElement, refWidth) {
    //   let totalWidth = 0;
    //   let count = 0;

    //   for (const child of ulElement.children) {
    //     const childWidth = child.getBoundingClientRect().width;
    //     totalWidth += childWidth;
    //     count++;
    //     console.log("maxVisibleSelections", totalWidth+(10*count), refWidth, count)
    //     if ((totalWidth + 10*count) > (refWidth - 80)) {
    //       console.log("maxVisibleSelections first true",)
    //       if((totalWidth + 10*count)>(refWidth)){
    //         console.log("maxVisibleSelections second true",)

    //         return count-2;
    //       }
    //     else
    //       return count-1; // Exit early when condition is matched
    //     }

    //   }
    //   return count; // If the reference width is never exceeded
    // // }

    // function getVisibleChildren1(ulElement, refWidth) {
    //   let totalWidth = 0;
    //   let count = 0;
    //   const spacingPerChild = 10; // Additional spacing between children
    //   const reservedWidthForBox = 19; // Fixed width for the "X more" box

    //   for (let i = 0; i < ulElement.children.length; i++) {
    //     const child = ulElement.children[i];
    //     const childWidth = child.getBoundingClientRect().width;
    //     totalWidth += childWidth;
    //     count++;

    //     const totalWithSpacing = totalWidth + spacingPerChild * count;

    //     console.log(
    //       "maxVisibleChildren loop ,",
    //       child.textContent,
    //       `, count: ${count}, totalWidth: ${totalWidth}, totalWithSpacing: ${totalWithSpacing}, refWidth: ${refWidth}`
    //     );

    //     // Condition to check if the "1 more" box fits
    //     if (totalWithSpacing + reservedWidthForBox > refWidth) {
    //       console.log(
    //         "maxVisibleChildren condition 1",
    //         `count: ${count}, totalWithSpacing: ${totalWithSpacing}, reservedWidthForBox: ${reservedWidthForBox}`
    //       );

    //       // Check if the last child can fit instead of the "1 more" box
    //       if (totalWithSpacing <= refWidth) {
    //         console.log(
    //           "maxVisibleChildren condition 2 (last child fits)",
    //           `count: ${count}, totalWithSpacing: ${totalWithSpacing}`
    //         );
    //         return count;
    //       }

    //       console.log(
    //         "maxVisibleChildren condition 3 (needs '1 more' box)",
    //         `count: ${count - 1}, totalWithSpacing: ${totalWithSpacing}`
    //       );

    //       // Otherwise, exclude the current child and reserve space for "1 more"
    //       return count - 1;
    //     }
    //   }

    //   // If we get here, all children fit, including spacing
    //   console.log("maxVisibleChildren all fit", `count: ${count}, totalWidth: ${totalWidth}, refWidth: ${refWidth}`);

    //   return count + 1;
    // }

    // function getVisibleChildren2(ulElement, refWidth) {
    //   let totalWidth = 0;
    //   let count = 0;
    //   let visibleSelections = 0;
    //   const spacingPerChild = 10; // Additional spacing between children
    //   const reservedWidthForBox = 19.25; // Fixed width for the "X more" box

    //   for (let i = 0; i < ulElement.children.length; i++) {
    //     const child = ulElement.children[i];
    //     const childWidth = child.getBoundingClientRect().width;

    //     if (child.textContent.includes("more")) {
    //       console.log("maxVisibleChildren visibleSelections", visibleSelections);
    //       return visibleSelections;
    //     }
    //     totalWidth += childWidth;
    //     count++;

    //     const totalWithSpacing = totalWidth + spacingPerChild * count;

    //     console.log(
    //       "maxVisibleChildren loop",
    //       `count: ${count}, totalWidth: ${totalWidth}, totalWithSpacing: ${totalWithSpacing}, refWidth: ${refWidth}`
    //     );

    //     // Check if total width exceeds the available width
    //     if (totalWithSpacing > refWidth) {
    //       console.log(
    //         "maxVisibleChildren condition 1 (totalWithSpacing exceeds refWidth)",
    //         `count: ${count}, totalWithSpacing: ${totalWithSpacing}, refWidth: ${refWidth}`
    //       );

    //       // Check if excluding the current child makes room for the box
    //       if (totalWithSpacing - childWidth + reservedWidthForBox <= refWidth) {
    //         console.log(
    //           "maxVisibleChildren condition 2 (fits with box after excluding last child)",
    //           `count: ${count - 1}, totalWidth after removal: ${totalWithSpacing - childWidth}`
    //         );
    //         visibleSelections = count - 1;
    //         return count - 1; // Exclude current child, include the box
    //       }

    //       // If the box still doesn't fit, exclude another child
    //       console.log(
    //         "maxVisibleChildren condition 3 (reduce further for box)",
    //         `count: ${count - 2}, totalWidth after further adjustment: ${totalWithSpacing - childWidth}`
    //       );
    //       visibleSelections = count - 2;
    //       return count - 2; // Exclude one more child
    //     }
    //   }

    //   // If all children fit, return the count
    //   console.log("maxVisibleChildren all fit", `count: ${count}, totalWidth: ${totalWidth}, refWidth: ${refWidth}`);
    //   visibleSelections = count + 1;
    //   return count + 1;
    // }
    console.log("valuevalue", value);
    function getVisibleChildren(container, refWidth) {
      let totalWidth = 0;
      let count = 0;
      const spacingPerChild = 4; // matches gap-1 in Tailwind (0.25rem)
      const reservedWidthForBox = 19; // approximate width for the "+N" span (px)

      // only measure actual tag spans (exclude the "+N" counter)
      const tagElements = Array.from(container.querySelectorAll('[data-role="tag"]'));

      for (let i = 0; i < tagElements.length; i++) {
        const childWidth = tagElements[i].getBoundingClientRect().width;
        totalWidth += childWidth;
        count++;

        // include spacing for each rendered child after the first
        const totalWithSpacing = totalWidth + spacingPerChild * (count - 1);

        // if adding reserved box overflows, exclude current and stop
        if (totalWithSpacing + reservedWidthForBox > refWidth) {
          return Math.max(0, count - 1);
        }
      }

      // all tag items fit without needing box
      return count;
    }

    if (selectedOptions.length > 1) {
      const visibleChildren = getVisibleChildren(refChild.current, refChild.current.getBoundingClientRect().width);
      // if (visibleChildren > 0)
      setMaxVisibleSelections(visibleChildren);
    }
  }, [selectedOptions]);

  return (
    <div ref={ref} className={`relative w-full ${minWidth}`} tabIndex={0} comboBox="true">
      {/* Select Input */}
      <div
        onClick={() => {
          if (disabled) return;
          toggleDropdown();
          setInitiated(true);
        }}
        ref={refSelect}
        className={`flex items-center justify-between w-full ${className} border rounded-md ${disabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} cursor-pointer ${size === "small" ? `h-[25px]` : size === "large" ? "h-[36px]" : `h-[30px]`} focus:ring-2 focus:ring-indigo-500 ${dynamicClassDefinition()} ${heightFull && "h-full"} ${isRounded ? "rounded-md" : ""} ${hideBorder && "border-none"}`}
        style={{ padding: size === "small" ? "0.3rem 0.4rem" : "0.714rem " }}
      >
        <div
          ref={refChild}
          className={`flex flex-wrap items-center justify-${textPosition} gap-1 overflow-hidden w-full`}
        >
          {startAdornment && <span>{startAdornment}</span>}

          {/* Render Selected Options */}
          {selectedOptions.length > 0 ? (
            <>
              {Array.isArray(visibleSelections) &&
                visibleSelections?.length > 0 &&
                visibleSelections?.map((option) => (
                  <span
                    key={option}
                    data-role="tag"
                    className={`flex max-w-full flex-shrink truncate px-1 overflow-hidden whitespace-nowrap items-center text-sm ${multiSelect ? (isTagList ? `text-[#ffffff]` : "bg-indigo-100 text-indigo-600") : ""} rounded-sm gap-1 cursor-pointer hover:bg-indigo-200`}
                    style={{
                      backgroundColor: `${!option?.[colorKey] ? "#F0F5F9" : "transparent"}`,
                      border: `${option?.[colorKey] && "1px solid"} ${option?.[colorKey] && option?.[colorKey]}`,
                      color: option?.[colorKey] ? option?.[colorKey] : "#666666",
                    }}
                  >
                    {option?.[labelKey]}
                    {(multiSelect || nullSelector) && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRemoveOption(option);
                        }}
                        disabled={disabled}
                        className={`ml-1 ${isTagList ? `text-[#ffffff]` : "text-indigo-700"} hover:text-red-500 focus:outline-none`}
                        style={{
                          color: isTagList && option?.color,
                        }}
                      >
                        <CrossCircle />
                      </button>
                    )}
                  </span>
                ))}

              {/* "X More" Indicator */}
              {hiddenCount > 0 && (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsOpen(true); // Open the dropdown
                  }}
                  className="flex items-center px-1 text-sm bg-gray-100 text-gray-600 rounded-md cursor-pointer hover:bg-gray-200"
                >
                  +{hiddenCount}
                </span>
              )}
            </>
          ) : displayValue ? (
            displayValue ||
            ""?.split(",")?.map((value, index) => (
              <span key={index} className="text-sm bg-[#F0F5F9] text-[#666666] px-2 rounded-sm">
                {value}
              </span>
            ))
          ) : (
            <span className="text-[#AFAFAF] text-sm">{placeholder}</span>
          )}
        </div>

        {endAdornment ? (
          endAdornment
        ) : (
          <DownArrow
            fill={`#535252`}
            className={`${isOpen ? "rotate-180 " : "rotate-0"} transition-all duration-300`}
          />
        )}
      </div>

      {/* Dropdown */}
      {/*  {isOpen && (
        // ref for HOC Component
        <div className="absolute left-0 right-0 mt-2 border rounded-lg bg-white shadow-lg z-10">
          <List
            options={options}
            selectedOptions={selectedOptions}
            onOptionClick={handleChangeOptionClick}
            multiSelect={multiSelect}
            // listOpen
            toggleButtons={toggleButtons}
          />
        </div>
      )} */}

      {isOpen && (
        <PortalList
          open={isOpen}
          expendedList={expendedList}
          onClose={() => {
            if (noFormInput) {
              listCloseHandler(latestSelectedOptionsRef.current);
            } else {
              listCloseHandler({
                target: {
                  value: latestSelectedOptionsRef.current?.map((item) => item?.value),
                  name: name,
                  ...latestSelectedOptionsRef.current?.[0]?.additionFields,
                },
              });
            }
            setIsOpen(false);
            onBlur();
          }}
          containerRef={ref}
          boxWidth={boxWidth}
          options={options === null && apiMetaData !== null ? apiOptionsData : options}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          onOptionClick={handleChangeOptionClick}
          labelKey={labelKey}
          sublabelKey={sublabelKey}
          valueKey={valueKey}
          colorKey={colorKey}
          multiSelect={multiSelect}
          showSearch={showSearch}
          personList={personList}
          isTagList={isTagList}
          isEditList={isEditList}
          inlineCrud={inlineCrud}
          editListHandler={editListHandler}
          toggleButtons={toggleButtons}
          addButton={addButton}
          size={size}
          addButtonLabel={addButtonLabel}
          addButtonAction={addButtonAction}
          refreshList={() => setRefreshCount(refreshCount + 1)}
          noChildren={noChildren}
          showCheckBox={showCheckBox}
          isCompareValue={isCompareValue}
          handleSelectAllOptionsClick={handleSelectAllOptionsClick}
        />
      )}
    </div>
  );
};

export default SelectComponent;
